import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { OIDCHttpClient } from "lib/oidc_http_client";
import { QuoteBilling } from "types/quote-billing";

export const useSendQuote = (quote: QuoteBilling, options: UseMutationOptions) => {
  const postSendQuote = async () => {
    const url = `${process.env.REACT_APP_API_URL}/murfy-erp/customer-file/${quote.customer_file}/send-quote/`;
    const client = new OIDCHttpClient();
    return await client.post(url, {
      payload: {
        quote_id: quote.id,
      },
    });
  };
  return useMutation({
    ...options,
    mutationFn: postSendQuote,
  });
};
